import { Component } from '@angular/core';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: []
})
export class PricingComponent {
  constructor() {
    window.scrollTo(0, 0);
  }
  page: number = 0;
  imgSrcList = [
    'assets/img/sunum2-1.jpg',
    'assets/img/sunum2-2.jpg',
    'assets/img/sunum2-3.jpg',
    'assets/img/sunum2-4.jpg',
    'assets/img/sunum2-5.jpg',
    'assets/img/sunum2-6.jpg',
    'assets/img/sunum2-7.jpg',
    'assets/img/sunum2-8.jpg',
    'assets/img/sunum2-9.jpg',
    'assets/img/sunum2-10.jpg',
    'assets/img/sunum2-11.jpg',
    'assets/img/sunum2-12.jpg',
    'assets/img/sunum2-13.jpg',
    'assets/img/sunum2-14.jpg',
    'assets/img/sunum2-15.jpg',
    'assets/img/sunum2-16.jpg',
    'assets/img/sunum2-17.jpg',
    'assets/img/sunum2-18.jpg',
    'assets/img/sunum2-19.jpg',
    'assets/img/sunum2-20.jpg',
    'assets/img/sunum2-21.jpg'
  ]
}
